const LINKABLE_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);

export const isLinkableHref = (href: string) => {
  try {
    return LINKABLE_PROTOCOLS.has(new URL(href, "http://localhost").protocol);
  } catch {
    return false;
  }
};
